import axios from 'axios';
import { Loading } from 'element-ui';
import _ from 'lodash';

// axios 拦截器
axios.interceptors.response.use(data => data, () => {
        return Promise.resolve({
            data: {
                code: 400
            }
        });
    }
)

const fetch = {
    interfaceUrl: function() {
        let path = ''
        //接口地址
        return _.isEmpty(process.env.VUE_APP_API_URI) ? path : process.env.VUE_APP_API_URI + path
    },

    request: async function(url, data = {}, method, showLoading = true, type = false, auth = false) {
        let loadingInstance
        if (showLoading) {
            loadingInstance = Loading.service({
                fullscreen: true,
                text: ''
            })
        }

        // 产品
        let product = window.localStorage.getItem('product')
        product = product ? product : 'mz'

        const options = {
            data,
            method,
            url: fetch.interfaceUrl() + url,
            headers: {
                'content-type': type ? 'application/x-www-form-urlencoded' : 'application/json',
                'accept': 'application/json',
                'Product': product,
            }
        }

        let response = await axios(options)
        showLoading && loadingInstance.close()
        return response.data
    },
}

export default fetch
